import { render } from "./RightDesktopBar.vue?vue&type=template&id=518978d4&scoped=true"
import script from "./RightDesktopBar.vue?vue&type=script&lang=js"
export * from "./RightDesktopBar.vue?vue&type=script&lang=js"

import "./RightDesktopBar.vue?vue&type=style&index=0&id=518978d4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518978d4"]])

export default __exports__